import _ from "lodash"
import haversineDistance from "haversine-distance";

const stdMapMarker = '<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="10" stroke="black" stroke-width="2" fill="lightblue" /><circle cx="30" cy="30" r="3" stroke="black" stroke-width="2" fill="blue" /></svg>';

//function that adds marker to map that does center the map
export const addMarkertoMap = (mapObject, coords, markup=stdMapMarker) =>{

    
    if(!mapObject){
        console.error("map not found")
        return;
    }
    //if(!coords.lat !coords.lng)
    //console.log(isNaN(coords.lat) || coords.lat === undefined || coords.lat === null)
    if (isNaN(coords.lat) || coords.lat === undefined || coords.lat === null) { 
        console.log("Coords are non-viable", coords);
        return;
    }

    if (isNaN(coords.lng) || coords.lng === undefined || coords.lng === null) { 
        console.log("Coords are non-viable", coords);
        return;
    }
    const H = mapObject.H
    const hMap = mapObject.hMap
    var icon2 = new H.map.Icon(markup)
    const marker = new H.map.Marker(coords , {icon: icon2});
    hMap.addObject(marker)
    hMap.setCenter(coords)
    //centerMap(mapObject) 
}

//adds marker to map that doesn't center the map 
export const addMarkertoMapNonCenter = (mapObject, coords, markup=stdMapMarker) =>{
    if (coords && coords.lat !== undefined && coords.lat !== null && coords.lat <= 0.01 && coords.lng <= 0.01) { 
        console.log("Coords are non-viable", coords);
        return;
    }
    const H = mapObject.H
    const hMap = mapObject.hMap
    var icon2 = new H.map.Icon(markup)
    const marker = new H.map.Marker(coords , {icon: icon2});
    hMap.addObject(marker)
    //hMap.setCenter(coords)
}

//function that removes all marker 
export const removeAllMarker = (mapObject) =>{
    if(!mapObject){
        console.error("map not found")
        return;
    }

    const hMap = mapObject.hMap
    if(hMap.getObjects().length > 0){
        hMap.removeObjects(hMap.getObjects());
    } 
} 

export const centerMap = (mapObject) => {
    
    const H = mapObject.H
    const hMap = mapObject.hMap
    var group = new H.map.Group()
    var arr = hMap.getObjects()
    var arrNew = _.cloneDeep(arr)
    console.log(arrNew)

    if (group && group.getBoundingBox()) {
        console.log("map bounding box from center map",group.getBoundingBox())
        hMap.getViewModel().setLookAtData({
            zoom: 5,
            bounds:group.getBoundingBox()
        });
    } else {
        console.error("map setLookAt group bounding box does not work");
    }  
}

//
export const addMarkertoMapGroupNoCenter = (mapObject, coordsContact, coordsProvider, markupProvider) =>{
    
    if(!mapObject){
        console.error("map not found")
        return;
    }
    
    // ! this will like never happen - what was original intent and how to make work?
    removeAllMarker(mapObject)

    //builds and adds the group to the map
    const H = mapObject.H
    const hMap = mapObject.hMap
    var icon2 = new H.map.Icon(stdMapMarker)
    var icon3 = new H.map.Icon(markupProvider)
    const marker = new H.map.Marker(coordsContact , {icon: icon2});
    const marker2 = new H.map.Marker(coordsProvider , {icon: icon3});
    var group = new H.map.Group()
    group.addObjects([marker, marker2])
    hMap.addObject(group)

}

export const addMarkertoMapGroup = (mapObject, coordsContact, coordsProvider, markupProvider, DestMapMarker) =>{

    if(!mapObject){
        console.error("map not found")
        return;
    }

    //checks to see if default value will return
    if (coordsProvider && coordsProvider.lat !== undefined && coordsProvider.lat !== null 
        && coordsProvider.lat <= 0.01 && coordsProvider.lng <= 0.01) { 
        console.log("Provider Coords are non-viable", coordsProvider);
        return;
    }

    var tempMarker = {}
    if(DestMapMarker){
        tempMarker = DestMapMarker 
    }
    else {
        tempMarker = stdMapMarker
    }

    //builds and adds the group to the map
    const H = mapObject.H
    const hMap = mapObject.hMap
    var icon2 = new H.map.Icon(tempMarker)
    var icon3 = new H.map.Icon(markupProvider)
    const marker = new H.map.Marker(coordsContact , {icon: icon2});
    const marker2 = new H.map.Marker(coordsProvider , {icon: icon3});
    var group = new H.map.Group()
    group.addObjects([marker, marker2])
    hMap.addObject(group)

    //create a mutable clone of the boundingBox Obj
    var tempObj = _.cloneDeep(group.getBoundingBox())

    //console.log(hMap.setZoom(15))
    // TODO THIS IS THE ISSUE THAT WE ARE DEALING WITH HERE
    console.log(group.getBoundingBox())
    console.log("map bounding box from center map",group.getBoundingBox())
    //get the distance
    const distMeters = haversineDistance(coordsContact, coordsProvider)

    //simple if statement to adjust for various distances
    if(distMeters < 1600){
        tempObj.ca = tempObj.ca - .01
        tempObj.ia = tempObj.ia + .01
        tempObj.la = tempObj.la + .01
        tempObj.na = tempObj.na - .01
    }
    else if(distMeters < 16000){
        tempObj.ca = tempObj.ca - .02
        tempObj.ia = tempObj.ia + .02
        tempObj.la = tempObj.la + .02
        tempObj.na = tempObj.na - .02
    }
    else{
        tempObj.ca = tempObj.ca - .2
        tempObj.ia = tempObj.ia + .2
        tempObj.la = tempObj.la + .2
        tempObj.na = tempObj.na - .2
    }

    //set bounds of that value to the map
    if (tempObj) {
        console.log("map bounding box from group creation map",tempObj)
        hMap.getViewModel().setLookAtData({
            bounds:tempObj,
            //zoom : 15,
        });
    } else {
        console.error("Map LookAtData Error: tempObj error");
    }
    //hMap.setZoom(15)
    //console.log(hMap.getZoom())
    
}
